<div class="modal-header">
    <h5 class="modal-title">{{title}}</h5>
    <button type="button" class="btn-close" (click)="dismissModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <h3 class="mb-4">{{prompt}}</h3>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-round btn-lg btn-outline-black" (click)="dismissModal()"><i class="far fa-times"></i> Cancel</button>
    <button type="submit" class="btn btn-round btn-lg btn-secondary" (click)="confirmModal(false)"><i class="far fa-times"></i> No</button>
    <button type="submit" class="btn btn-round btn-lg btn-secondary" (click)="confirmModal(true)"><i class="far fa-check"></i> Yes</button>
</div>